import { Stack, Typography, Box } from "@mui/material";
import { type FC } from "react";
import { Translate, useTranslation } from "@privacy/translations";
import { useMutation } from "@tanstack/react-query";
import * as FormDialog from "../../../shared/FormDialog";
import { usePrivacyNavigate } from "../../../shared/usePrivacyNavigate";

type LosePermissionToUpdateRolesDialogProps = {
  onCancel: () => void;
  onConfirm: () => Promise<unknown>;
};

export const LosePermissionToUpdateRolesDialog: FC<LosePermissionToUpdateRolesDialogProps> = ({
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();
  const { navigate, paths } = usePrivacyNavigate();
  const mutation = useMutation({ mutationFn: onConfirm, onSuccess: () => navigate(paths.root()) });

  return (
    <FormDialog.Dialog maxWidth="40rem" isOpen={true}>
      <FormDialog.Title>{t("Settings.LosePermissionToUpdateRolesDialog.Header")}</FormDialog.Title>
      <FormDialog.Form onSubmit={() => mutation.mutate()}>
        <FormDialog.Content>
          <FormDialog.FormError isError={mutation.isError} />
          <FormDialog.Fields>
            <Stack spacing={5}>
              <Typography variant="body2">
                <Translate
                  translationKey="Settings.LosePermissionToUpdateRolesDialog.Body"
                  values={{
                    role: (
                      <Box component="span" sx={{ fontWeight: "bold" }}>
                        {t("Roles.PRODUCT_ADMIN")}
                      </Box>
                    ),
                    view: (
                      <Box component="span" sx={{ fontWeight: "bold" }}>
                        {t("Settings.LosePermissionToUpdateRolesDialog.Body.SettingsViewName")}
                      </Box>
                    ),
                  }}
                />
              </Typography>

              <FormDialog.ActionButtons>
                <FormDialog.CancelButton onClick={() => onCancel()}></FormDialog.CancelButton>
                <FormDialog.SubmitButton isSubmitting={mutation.isPending}>
                  {t("Settings.LosePermissionToUpdateRolesDialog.RemoveButton")}
                </FormDialog.SubmitButton>
              </FormDialog.ActionButtons>
            </Stack>
          </FormDialog.Fields>
        </FormDialog.Content>
      </FormDialog.Form>
    </FormDialog.Dialog>
  );
};
